<template>
  <div>
    <div class="bootstrap-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-8 nohover">
            <div class="map">
              <div class="title">
                <div style="display:flex;flex-direction:column;height:100%;justify-content:center;align-items:center;font-weight:bold;">{{ $root.data.info.name }}</div>
              </div>
  
              <gmap-map v-if="location" ref="map" :options="{disableDefaultUI:true}" mapTypeId="satellite" :center="location" :zoom="14" style="width: 100%; height: 100%;">
                <gmap-marker :position="location" :clickable="false" :draggable="false"></gmap-marker>
              </gmap-map>
            </div>
          </div>
                    
          
          <!--<div class="col-md-4 nohover" @click="go({id:'nu'})">
        		<div class="content" :style="infoBoxStyle">
          		<img v-if="ok" src="../assets/ok.png" width="100">
          		<img v-if="!ok" class="pulse" src="../assets/alert.png" width="100">
          		<div v-if="!ok">(tryck för mer information)</div>
              
        		</div>
          </div>-->
          <div class="col-md-4" @click="go({id:'enheter'})">
        		<div class="content" :style="style({color:'#275476'})">
          		<div class="image">
          		  <img src="../assets/nexa/enheter.png" :width="iconSize">
          		</div>
        		  <div class="head">Enheter</div>
        		  <div class="descr2">Totalt {{ $root.data.nodes.length }} enhet{{ $root.data.nodes.length !== 1 ? 'er' : '' }}</div>
        		</div>
          </div>
          
          <div class="col-md-4" @click="go({id:'rum'})">
        		<div class="content" :style="style({color:'#7890a6'})">
          		<div class="image">
          		  <img src="../assets/nexa/rum.png" :width="iconSize">
          		</div>
          		
        		  <div class="head">Rum</div>
        		  <div class="descr2" v-if="!countData('rooms')">Visa och hantera dina rum</div>
        		  <div class="descr2" v-else>Du har {{ countData('rooms') }} rum tillagda</div>
        		</div>
          </div>
          
          <div class="col-md-4" @click="go({id:'schemalaggningar'})">
        		<div class="content" :style="style({color:'#a9cf5e'})">
          		<div class="image">
          		  <img src="../assets/nexa/schemalaggningar.png" :width="iconSize">
          		</div>
          		
        		  <div class="head">Schemaläggningar</div>
        		  <div class="descr2">Utför händelser vid tid</div>
        		</div>
          </div>

          <div class="col-md-4" @click="go({id:'aktivitetslogg'})">
        		<div class="content" :style="style({color:'#689294'})">
          		<div class="image">
          		  <img src="../assets/nexa/aktivitetslogg.png" :width="iconSize">
          		</div>
          		
        		  <div class="head">Historik</div>
        		  <div class="descr2">Vad som händer & hänt i ditt hem</div>
        		</div>
          </div>
          
          <div class="col-md-4" @click="go({id:'scenarion'})">
        		<div class="content" :style="style({color:'#3a68bd'})">
          		<div class="image">
          		  <img src="../assets/nexa/scenario.png" :width="iconSize">
          		</div>
          		
        		  <div class="head">Scenarion</div>
        		  <div class="descr2">Tänd eller släcker enheter enkelt</div>
        		</div>
          </div>
                    
          <div class="col-md-4" @click="go({id:'automationer'})">
        		<div class="content" :style="style({color:'#f36b51'})">
          		<div class="image">
          		  <img src="../assets/nexa/automationer.png" :width="iconSize">
          		</div>
          		
          		<div class="head">Automationer</div>
        		  <div class="descr2">Automatisera ditt hem</div>
        		</div>
          </div>
                              
          <div class="col-md-4" @click="go({id:'installningar'})">
        		<div class="content" :style="style({color:'#acacae'})">
          		<div class="image">
          		  <img src="../assets/nexa/installningar.png" class="rotate" :width="iconSize">
          		</div>
          		
          		<div class="head">Inställningar</div>
        		  <div class="descr2">Inställningar för {{ $root.data.info.name }}</div>
        		</div>
          </div>

          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'

  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyD2JcbcYQfyrN_Rl5_D2TrOu5Kd59juy_4'
    }
  })
  
  export default {
    name: 'startpage',
    data: () => ({
      iconSize: 55
    }),
    created () {},
    methods: {
      go (item) {
        this.$router.push({
          name: item.id
        })
      },
      
      style (item) {
        return {
          'background-color': item.color
        }
      },

      countCapAndValue (capability, comparator, value) {
        let count = 0
        this.$root.data.nodes.forEach(node => {
          if (node.capabilities.includes(capability) && capability in node.lastEvents) {
            const event = node.lastEvents[capability]
            if (comparator != undefined && value != undefined) {
                if (this.compare(event.value, comparator, value)) {
                  count++
              }
            } else {
              count++
            }
          }
        })
        
      
        return count
      },
      
      compare(value, comparator, to) {
        switch (comparator) {
          case '===': return value === to; break
          case '>': return value > to; break
        }
      },
      
      countData (name) {
        return this.$root.data[name].filter(x => x.id > 0).length
      }
    },
    
    computed: {
      on () {
        const caps = ['switchBinary', 'switchLevel']
        
        const nodes = this.$root.data.nodes.filter(node => {
          return node.capabilities.some(v => caps.includes(v))
        })
  
        return nodes
      },
      //
      infoBoxStyle () {
        return {
          'justify-content': 'center',
          'text-align': 'left',
          'color': '#D0443E',
          'border': '1px solid ' + (!this.ok ? '#D0443E' : '#7CB621'),
          'font-size': '13px',
          'box-shadow': 'none',
          'padding-top': '5px',
        }
      },
      
      ok () {
        const motion = this.countCapAndValue('notificationMotion', '===', true)        
        const contact = this.countCapAndValue('notificationContact', '===', true)        
        const smoke = this.countCapAndValue('notificationSmoke', '===', true)        
        const water = this.countCapAndValue('notificationWater', '===', true)        

        return !(motion > 0 || contact > 0 || smoke > 0 || water > 0)
      },
    
      favorites () {
        const nodes = this.$root.data.nodes.filter(node => node.favorite)
        const scenarios = this.$root.data.scenarios.filter(scenario => scenario.favorite)

        return { nodes, scenarios }
      },
      
      /*
        TODO: använd någon standardposition här, exempelvis Göteborg,
        så det inte blir en laddning.
      */
      location () {
        if ('location' in this.$root.data.info) {
          return {
            lat: this.$root.data.info.location.lat, 
            lng: this.$root.data.info.location.lon 
          }
        }
      }
    }
  }
</script>

<style scoped>
  div[class*="col-md-"] {
    margin:0px;
    padding:2px;
    transition:all 0.3s ease;
  }

  div[class*="col-md-"] .content, div[class*="col-md-"] .map {
    text-align: center;
    height:150px;
    border-radius: 4px;
    color:#FFF;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  
      
  .map .title {
    position:absolute;
    height:100%;
    width:100%;
    z-index:1;
    color:#FFF;
    font-size:35px;
  }
  
  @media only screen and (min-width: 450px) {
    div[class*="col-md-"] .content, div[class*="col-md-"] .map {
      height:200px;
    }
    
    .map .title {
      position:absolute;
      height:100%;
      width:100%;
      z-index:1;
      color:#FFF;
      font-size:45px;
    }
  }
  
  div[class*="col-md-"] .content .head {
    font-size:16px;
  }

  .image {
    padding-bottom:10px;
  }

  div[class*="col-md-"] .content .descr {
    font-size:13px;
    color:rgba(255, 255, 255, 0.6)
  }

  div[class*="col-md-"]:not(.nohover):hover {
    cursor:pointer;
    -webkit-transform: scale(0.99);
    -ms-transform: scale(0.99);
    transform: scale(0.99);
  }

  .descr2 {
    font-size:12px;
    color:#fff;
    margin-top:0px;
  }
  
  .rotate {
    animation-name: spin;
    animation-duration: 20000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear; 
  }
    
  @keyframes spin {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/startpage.vue